<template>
  <app-modal
    name="dialog"
    width="600px"
    :title="params.title"
    :ok-text="params.okText"
    :ok-class="params.okClass"
    :cancel-text="params.cancelText"
    :isSubmitting="isSubmitting"
    :isAlert="params.isAlert"
    @on-ok="onOk"
    @on-cancel="onCancel"
    @before-close="beforeClose"
    @before-open="beforeOpen"
  >
    <div v-if="params.content" v-html="params.content"></div>
    <p v-else>{{ params.text }}</p>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';

export default {
  name: 'AppDialog',
  components: {
    AppModal,
  },
  data() {
    return {
      isSubmitting: false,
      params: this.getDefaultParams(),
    };
  },
  methods: {
    getDefaultParams() {
      return {
        content: null,
        title: '',
        okText: '',
        cancelText: '',
        text: '',
        showLoading: false,
        isAlert: false,
      };
    },
    beforeOpen(params) {
      this.params = { ...this.params, ...params };
    },
    async beforeClose(event) {
      if (this.params.beforeClose) {
        await this.params.beforeClose(event);
      }
      this.params = this.getDefaultParams();
    },
    async onOk(model) {
      if (this.params.onOk) {
        if (this.params.showLoading) this.isSubmitting = true;
        await this.params.onOk(model);
        this.isSubmitting = false;
      }
      this.$modal.hide('dialog', { isOk: true });
    },
    async onCancel(model) {
      if (this.params.onCancel) {
        await this.params.onCancel(model);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/app-modal/confirm-dialog.vue